import React, { useEffect, useState } from 'react';

import LandingPage from './landing';

const Index = () => {
  return <LandingPage />;
};

export default Index;
